import config from './config';
import DDLogs from './DDLogs';
import anonymousSession from './anonymousSession';

let incognito = false;
/* eslint-disable */
const Segment = {
  install(Vue, options) {
    !function () {
      var analytics = window.analytics = window.analytics || [];
      if (!analytics.initialize) if (analytics.invoked) window.console && console.error && console.error("Segment snippet included twice."); else {
        analytics.invoked = !0;
        analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group", "track", "ready", "alias", "debug", "page", "once", "off", "on"];
        analytics.factory = function (t) {
          return function () {
            var e = Array.prototype.slice.call(arguments);
            e.unshift(t);
            analytics.push(e);
            return analytics
          }
        };
        for (var t = 0; t < analytics.methods.length; t++) {
          var e = analytics.methods[t];
          analytics[e] = analytics.factory(e)
        }
        analytics.load = function (t, e) {
          var n = document.createElement("script");
          n.type = "text/javascript";
          n.async = !0;
          n.src = "https://cdn.segment.com/analytics.js/v1/" + t + "/analytics.min.js";
          var a = document.getElementsByTagName("script")[0];
          a.parentNode.insertBefore(n, a);
          analytics._loadOptions = e
        };
        analytics.SNIPPET_VERSION = "4.1.0";
        analytics.load(config.get().segmentSourceId);
        analytics.page();
      }}();
  },

  setIncognito(isIncognito) {
    incognito = isIncognito;
  },

  identifyAnonymousUser(data) {
    analytics.identify(anonymousSession.getId(), data);
    DDLogs.log('identify', data);
  },

  identifyCustomer(customerId, data) {
    analytics.identify(
      customerId,
      _.assign({ incognito }, data),
      {
        integrations: {
          'Facebook Pixel': false
        }
      });
    DDLogs.log('identify', _.assign({}, { customerId }, data));
  },

  trackUserInteraction(eventName, data) {
    analytics.track(eventName, _.assign({ incognito }, data, {
        eventType: 'interaction',
      }),
      {
        integrations: {
          'Facebook Pixel': false
        }
      });
    DDLogs.log(eventName, data);
  },

  trackUserInteractionToPixel(eventName, data) {
    analytics.track(eventName, _.assign({ incognito }, data, {
        eventType: 'interaction',
      }),
      {
        integrations: {
          'Facebook Pixel': true
        }
      });
    DDLogs.log(eventName, data);
  },

  trackUserGot(eventName, data) {
    analytics.track(eventName, _.assign({ incognito }, data, {
        eventType: 'push',
      }),
      {
        integrations: {
          'Facebook Pixel': false
        }
      });
    DDLogs.log(eventName, data);
  },
  trackUserGotToPixel(eventName, data) {
    analytics.track(eventName, _.assign({ incognito }, data, {
        eventType: 'push',
      }),
      {
        integrations: {
          'Facebook Pixel': true
        }
      });
    DDLogs.log(eventName, data);
  },
};

export default Segment;



// WEBPACK FOOTER //
// ./src/Segment.js